import { Skeleton } from '@mui/material';
import SoftBox from 'components/SoftBox';
import { v4 } from 'uuid';

const DataTableLoader = () => {
    return (
        <SoftBox p={3}>
            <SoftBox mb={3}>
                <Skeleton
                    variant='rounded'
                    width='100%'
                    height={40} />
            </SoftBox>

            {[...Array(5)].map(() => (
                <SoftBox
                    key={v4()}
                    mb={2}
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    {[...Array(6)].map(() => (
                        <Skeleton
                            key={v4()}
                            variant='rounded'
                            width='15%'
                            height={40} />
                    ))}
                </SoftBox>
            ))}

            <SoftBox mt={3}>
                <Skeleton
                    variant='rounded'
                    width='100%'
                    height={40} />
            </SoftBox>
        </SoftBox>
    );
};

export default DataTableLoader;